/* eslint-disable */
import { isEmpty } from 'lodash/fp'

// Declare Templates
let bcSfFilterTemplate = {
	'soldOutClass': 'sold-out',
	'saleClass': 'on-sale',
	'soldOutLabelHtml': '<div>' + bcSfFilterConfig.label.sold_out + '</div>',
	'saleLabelHtml': '<div>' + bcSfFilterConfig.label.sale + '</div>',
	'vendorHtml': '<div>{{itemVendorLabel}}</div>',

	// Grid Template
	'productGridItemHtml': `
		<div class="product-tile product-tile--collection product-tile--{{itemTypeHandle}}">
			<div data-product-item{{itemThumbUrlAttribute}} class="product-tile__container">
				<a href="{{itemFirstVariantUrl}}" class="product-tile__link">
					<div class="product-tile__image-container">
						<img src="{{itemThumbUrl}}" class="product-tile__image" alt="{{itemTitle}}" />
						<div class="product-tile__image-container product-tile__image-container--alt{{itemHasModel}}">
							<img src="{{itemThumbUrlAlt}}" class="product-tile__image product-tile__image--alt" data-product-image-alt alt="{{itemTitle}}" />
						</div>
					</div>
				</a>
				{{quickAdd}}
				<div class="product-tile-sizes" data-product-sizes>
					<ul class="product-tile-sizes__list">
						{{itemSizes}}
					</ul>
				</div>

				<template data-quick-add-content>
					<div class="product-tile-modal__content">
						<header class="product-tile-modal__header">
							<button type="button" class="product-tile-modal__close product-tile-modal__close" aria-label="Close Quick Add" onclick="window.closeBCSFQuickAdd()">
								<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="15px" height="15px" viewBox="0 0 15 15" xml:space="preserve">
									<polygon fill="#0c2c4c" points="14.676,2.446 12.554,0.325 7.5,5.379 2.446,0.325 0.324,2.446 5.379,7.5 0.324,12.554 2.446,14.675 7.5,9.621 12.554,14.675 14.676,12.554 9.621,7.5 "/>
								</svg>
							</button>
						</header>

						<div class="product-tile-modal__product">
							<div class="product-tile-modal__product-image-holder">
								<img src="{{itemThumbUrl}}" class="product-tile-modal__product-image" alt="{{itemTitle}}" />
							</div>
							<div class="product-tile-modal__product-info">
								<h3 class="product-tile-modal__product-title">{{itemTitle}}</h3>
								<p class="product-tile-modal__product-type">{{itemType}}</p>
								{{itemRating}}
								<div class="product-tile-modal__product-info-footer">
									<p class="product-tile-modal__product-price">{{itemPrice}}</p>
									{{itemOptions}}
								</div>
							</div>
						</div>

						<div class="product-tile-modal__sizes">
							<p class="product-tile-modal__sizes-title">Choose your size.</p>

							<ul class="product__list product__list--size" data-product-sizes>
								{{itemSizes}}
							</ul>
						</div>

						<a 
							href="{{itemFirstVariantUrl}}" 
							class="product-tile-modal__button"
						>
							Learn More
						</a>
					</div>
				</template>
			</div>
			<a href="{{itemFirstVariantUrl}}" class="product-tile__info">
				<div class="product-tile__info-top">
					<h3 class="product-tile__title">{{itemTitle}}</h3>
					<p class="product-tile__price product-tile__price--top">{{itemPrice}}</p>
				</div>
				{{itemOptions}}
				<div class="product-tile__info-bottom">
					<h4 class="product-tile__type">{{itemType}}</h4>
				</div>
				<p class="product-tile__price product-tile__price--bottom">{{itemPrice}}</p>
				{{itemRating}}
				{{itemBadge}}
			</a>
		</div>
	`,
	// Pagination Template
	'previousActiveHtml': '<li><a href="{{itemUrl}}">&larr;</a></li>',
	'previousDisabledHtml': '<li class="disabled"><span>&larr;</span></li>',
	'nextActiveHtml': '<li><a href="{{itemUrl}}">&rarr;</a></li>',
	'nextDisabledHtml': '<li class="disabled"><span>&rarr;</span></li>',
	'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
	'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
	'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
	'paginateHtml': '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',

	// Sorting Template
	'sortingHtml': `
		<label for="collection-sort" class="visually-hidden">Sort Collection</label>
		<select id="collection-sort" class="collection-sort__input" title="Sort Collection">
			{{sortingItems}}
		</select>
	`
}

/** ************************ BUILD PRODUCT LIST **************************/

// Build Product Grid Item
/**
 * @param {very_long_type} name           Description.
 * @param {type}           very_long_name Description.
 */

function variantRealColor(variant) {
	return variant.title.replace(' / ' + variant.option_size, '')
}

function isFiltered() {
	const params = new URLSearchParams(window.location.search)
	let isFiltered = false

	for (let [key] of params) {
		if (key.includes('pf_')) {
			isFiltered = true
			break
		}
	}

	if (params.has('sort') && params.get('sort') !== '' && params.get('sort') !== 'manual') {
		isFiltered = true
	}

	if (params.has('pv')) {
		isFiltered = true
	}

	// Never allow filtering on collections with hidden option
	if (window.collectionHideOptions === 'true') {
		isFiltered = false
	}

	return isFiltered
}

BCSfFilter.prototype.buildProductGridItem = function(data, index) {
	// Check if carousels exist
	if (typeof window.collections !== 'undefined' && !isFiltered()) return ''
	if (data.images.length === 0) return ''

	let hiddenColors = []

	if (!data.hasOwnProperty('metafields')) {
		data.metafields = []
	}

	// Add hidden variants based on variant metafield `hidden`
	data.variants.forEach(variant => {
		data.metafields.forEach(metafield => {
			if (metafield.namespace === variant.id) {
				if (metafield.key === 'hidden' && metafield.value === 'true') {
					hiddenColors.push(variantRealColor(variant))
				}
			}
		})
	})

	let excludedFromPLP = data.tags.some(tag => tag === 'hidden-product')
	if (excludedFromPLP) return ''

	/** * Prepare data ***/
	let images = data.images_info
	let soldOut = !data.available // Check a product is out of stock
	let onSale = data.compare_at_price_min > data.price_min // Check a product is on sale
	let priceVaries = data.price_min != data.price_max // Check a product has many prices
	let colors = data.options_with_values.find(el => el.name === 'color')
	let colorCount
	let metaSubtitle = this.getProductMetafield(data, 'accentuate', 'subtitle')
	let isNewArrival = data.tags.some(tag => tag === 'new')
	let isWebExlusive = data.tags.some(tag => tag === 'web-exclusive')
	let isAccessory = data.tags.some(tag => tag === 'accessory_product')
	
	if (colors !== undefined) {
		colorCount = colors.values.length
	}

	// Get First Variant (selected_or_first_available_variant)
	let firstVariant = data['variants'][0]

	if (getParam('variant') !== null && getParam('variant') != '') {
		let paramVariant = data.variants.filter((e) => { return e.id == getParam('variant') })
		if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]
	} else {
		for (let i = 0; i < data['variants'].length; i++) {
			if (data['variants'][i].available) {
				firstVariant = data['variants'][i]
				break
			}
		}
	}
	/** * End Prepare data ***/

	// Get Template
	let itemHtml = bcSfFilterTemplate.productGridItemHtml

	// Set Product Type
	itemHtml = itemHtml.replace(/{{itemTypeHandle}}/g, data.product_type.toLowerCase().replace(/ /g,'-'))
	if (data.product_type === 'Bundle'){
		data.product_type = data.body_html.split('</p>')[0].split('<p>')[0]
	}

	// Add Thumbnail
	let itemThumbUrl = images.length ? this.optimizeImage(images[0]['src'], '480x') : bcSfFilterConfig.general.no_image_url
	itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl)

	// Add Hover Thumbnail
	let itemThumbUrlAlt = images.length > 1 ? this.optimizeImage(images[1]['src'], '480x') : bcSfFilterConfig.general.no_image_url
	itemHtml = itemHtml.replace(/{{itemThumbUrlAlt}}/g, itemThumbUrlAlt)

	// Hover thumbnail has model image
	let itemHasModel = itemThumbUrlAlt.includes('_101') ? ' has-model' : ''
	itemHtml = itemHtml.replace(/{{itemHasModel}}/g, itemHasModel)

	// Add Hover Attribute
	let itemThumbUrlAttribute = images.length > 1 ? ' data-toggle-product-image' : ''
	itemHtml = itemHtml.replace(/{{itemThumbUrlAttribute}}/g, itemThumbUrlAttribute)

	// Add Price
	let itemPriceHtml = ''
	if (data.title != '') {
		if (onSale) {
			itemPriceHtml = '<s class="product-tile__sale_price">' + this.formatMoney(data.compare_at_price_min) + '</s> '
		}
		itemPriceHtml = this.formatMoney(data.price_min)+' '+itemPriceHtml
	}

	itemHtml = itemHtml.replace(/{{itemPrice}}/g, () => { return itemPriceHtml })

	// Add soldOut class
	let soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : ''
	itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass)

	// Add onSale class
	let saleClass = onSale ? bcSfFilterTemplate.saleClass : ''
	itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass)

	// Add soldOut Label
	let itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : ''
	itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml)

	// Add onSale Label
	let itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : ''
	itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml)

	// Add Vendor
	let itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : ''
	itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml)

	// Get Size Index
	let size = {}
	let sizeIndex
	let sizeItemsArray = []
	let sizeItems = ''
	let amount = {}
	let amountindex
	data.options.filter((value, index) => {
		if (value.toLowerCase() === 'size') {
			size.index = (index + 1)
		}
	
	})
	data.options.filter((value, index) => {
	if(value.toLowerCase() === 'title'){
			amount.index = (index +1 )
		}
	})


	if (isEmpty(size)) {
		sizeIndex = null
	} else {
		sizeIndex = size.index
	}
	if (isEmpty(amount)) {
		amountindex = null
	} else {
		amountindex = amount.index
	}
	const quickAddhtml =  `
	<button type="button" data-product-quick-add class="product-tile__quick-add {{itemFirstVariantSku}}"{{itemQuickAddDisabled}}>
		<span>+</span><span>Quick Add</span>
	</button>
			<div class="product-tile__quick-add-mobile">
					<button type="button" data-product-quick-add class="product-tile__quick-add-mobile__button"{{itemQuickAddDisabled}}>
					<svg id="quick_add-color" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
					<circle id="Ellipse_101" data-name="Ellipse 101" cx="20" cy="20" r="20" fill="none"/>
					<g id="Subtraction_27" data-name="Subtraction 27" transform="translate(-1594 -5836.529)" fill="#fff">
					  <path d="M 1618.725708007812 5865.54052734375 L 1609.47021484375 5865.54052734375 C 1607.280639648438 5865.54052734375 1605.499389648438 5863.75927734375 1605.499389648438 5861.56982421875 L 1605.499389648438 5861.544921875 L 1605.501831054688 5861.52001953125 L 1606.658813476562 5849.95068359375 L 1606.703857421875 5849.50048828125 L 1607.156372070312 5849.50048828125 L 1621.03955078125 5849.50048828125 L 1621.492065429688 5849.50048828125 L 1621.537109375 5849.95068359375 L 1622.694091796875 5861.52001953125 L 1622.696533203125 5861.544921875 L 1622.696533203125 5861.56982421875 C 1622.696533203125 5863.75927734375 1620.915283203125 5865.54052734375 1618.725708007812 5865.54052734375 Z M 1610.79931640625 5856.7294921875 C 1610.634399414062 5856.7294921875 1610.500122070312 5856.86376953125 1610.500122070312 5857.02880859375 C 1610.500122070312 5857.19482421875 1610.634399414062 5857.32958984375 1610.79931640625 5857.32958984375 L 1613.200073242188 5857.32958984375 L 1613.700073242188 5857.32958984375 L 1613.700073242188 5857.82958984375 L 1613.700073242188 5860.22998046875 C 1613.700073242188 5860.39501953125 1613.834350585938 5860.529296875 1613.999389648438 5860.529296875 C 1614.165161132812 5860.529296875 1614.300048828125 5860.39501953125 1614.300048828125 5860.22998046875 L 1614.300048828125 5857.82958984375 L 1614.300048828125 5857.32958984375 L 1614.800048828125 5857.32958984375 L 1617.199340820312 5857.32958984375 C 1617.365112304688 5857.32958984375 1617.5 5857.19482421875 1617.5 5857.02880859375 C 1617.5 5856.86376953125 1617.365112304688 5856.7294921875 1617.199340820312 5856.7294921875 L 1614.800048828125 5856.7294921875 L 1614.300048828125 5856.7294921875 L 1614.300048828125 5856.2294921875 L 1614.300048828125 5853.830078125 C 1614.300048828125 5853.6640625 1614.165161132812 5853.529296875 1613.999389648438 5853.529296875 C 1613.834350585938 5853.529296875 1613.700073242188 5853.6640625 1613.700073242188 5853.830078125 L 1613.700073242188 5856.2294921875 L 1613.700073242188 5856.7294921875 L 1613.200073242188 5856.7294921875 L 1610.79931640625 5856.7294921875 Z" stroke="none"/>
					  <path d="M 1618.725708007812 5865.04052734375 C 1620.639526367188 5865.04052734375 1622.196533203125 5863.4833984375 1622.196533203125 5861.56982421875 L 1621.03955078125 5850.00048828125 L 1607.156372070312 5850.00048828125 L 1605.999389648438 5861.56982421875 C 1605.999389648438 5863.4833984375 1607.556396484375 5865.04052734375 1609.47021484375 5865.04052734375 L 1618.725708007812 5865.04052734375 M 1610.79931640625 5856.2294921875 L 1613.200073242188 5856.2294921875 L 1613.200073242188 5853.830078125 C 1613.200073242188 5853.388671875 1613.558715820312 5853.029296875 1613.999389648438 5853.029296875 C 1614.44091796875 5853.029296875 1614.800048828125 5853.388671875 1614.800048828125 5853.830078125 L 1614.800048828125 5856.2294921875 L 1617.199340820312 5856.2294921875 C 1617.640869140625 5856.2294921875 1618 5856.587890625 1618 5857.02880859375 C 1618 5857.47021484375 1617.640869140625 5857.82958984375 1617.199340820312 5857.82958984375 L 1614.800048828125 5857.82958984375 L 1614.800048828125 5860.22998046875 C 1614.800048828125 5860.6708984375 1614.44091796875 5861.029296875 1613.999389648438 5861.029296875 C 1613.558715820312 5861.029296875 1613.200073242188 5860.6708984375 1613.200073242188 5860.22998046875 L 1613.200073242188 5857.82958984375 L 1610.79931640625 5857.82958984375 C 1610.358642578125 5857.82958984375 1610.000122070312 5857.47021484375 1610.000122070312 5857.02880859375 C 1610.000122070312 5856.587890625 1610.358642578125 5856.2294921875 1610.79931640625 5856.2294921875 M 1618.725708007812 5866.04052734375 L 1609.47021484375 5866.04052734375 C 1607.005004882812 5866.04052734375 1604.999389648438 5864.03515625 1604.999389648438 5861.56982421875 L 1604.999389648438 5861.52001953125 L 1605.00439453125 5861.47021484375 L 1606.251342773438 5849.00048828125 L 1621.944580078125 5849.00048828125 L 1623.196533203125 5861.52001953125 L 1623.196533203125 5861.56982421875 C 1623.196533203125 5864.03515625 1621.19091796875 5866.04052734375 1618.725708007812 5866.04052734375 Z" stroke="none" fill="#fff"/>
					</g>
					<g id="Subtraction_26" data-name="Subtraction 26" transform="translate(-1590.1 -5840.801)" fill="#fff">
					  <path d="M 1607.399780273438 5857.5009765625 L 1607.398803710938 5857.5009765625 L 1606 5857.5 L 1605.500366210938 5857.49951171875 L 1605.500366210938 5857 L 1605.500366210938 5853.99951171875 C 1605.500366210938 5851.51806640625 1607.51904296875 5849.49951171875 1610.000366210938 5849.49951171875 L 1610.400146484375 5849.49951171875 C 1612.881469726562 5849.49951171875 1614.900146484375 5851.51806640625 1614.900146484375 5853.99951171875 L 1614.900146484375 5856.9990234375 L 1614.900146484375 5857.49853515625 L 1614.400512695312 5857.4990234375 L 1613.0009765625 5857.5 L 1612.500610351562 5857.50048828125 L 1612.500610351562 5857 L 1612.500610351562 5854.30078125 C 1612.500610351562 5853.0322265625 1611.468627929688 5852.00048828125 1610.2001953125 5852.00048828125 C 1608.931762695312 5852.00048828125 1607.899780273438 5853.0322265625 1607.899780273438 5854.30078125 L 1607.899780273438 5857 L 1607.899780273438 5857.5 L 1607.399780273438 5857.5009765625 Z" stroke="none"/>
					  <path d="M 1607.399780273438 5857.0009765625 L 1607.399780273438 5854.30078125 C 1607.399780273438 5852.7568359375 1608.656005859375 5851.50048828125 1610.2001953125 5851.50048828125 C 1611.744384765625 5851.50048828125 1613.000610351562 5852.7568359375 1613.000610351562 5854.30078125 L 1613.000610351562 5857 L 1614.400146484375 5856.9990234375 L 1614.400146484375 5853.99951171875 C 1614.400146484375 5851.7939453125 1612.605712890625 5849.99951171875 1610.400146484375 5849.99951171875 L 1610.000366210938 5849.99951171875 C 1607.794799804688 5849.99951171875 1606.000366210938 5851.7939453125 1606.000366210938 5853.99951171875 L 1606.000366210938 5857 L 1607.399780273438 5857.0009765625 M 1607.399780273438 5858.0009765625 L 1605.000366210938 5857.99951171875 L 1605.000366210938 5853.99951171875 C 1605.000366210938 5851.24267578125 1607.243408203125 5848.99951171875 1610.000366210938 5848.99951171875 L 1610.400146484375 5848.99951171875 C 1613.157104492188 5848.99951171875 1615.400146484375 5851.24267578125 1615.400146484375 5853.99951171875 L 1615.400146484375 5857.99853515625 L 1612.000610351562 5858.00048828125 L 1612.000610351562 5854.30078125 C 1612.000610351562 5853.30810546875 1611.192993164062 5852.50048828125 1610.2001953125 5852.50048828125 C 1609.207397460938 5852.50048828125 1608.399780273438 5853.30810546875 1608.399780273438 5854.30078125 L 1608.399780273438 5858 L 1607.399780273438 5858.0009765625 Z" stroke="none" fill="#fff"/>
					</g>
					<path id="Subtraction_21" data-name="Subtraction 21" d="M1618.726,5865.041h-9.255a3.475,3.475,0,0,1-3.471-3.471l1.157-11.569h13.883l1.157,11.569A3.475,3.475,0,0,1,1618.726,5865.041Zm-7.926-8.811a.8.8,0,0,0,0,1.6h2.4v2.4a.8.8,0,0,0,1.6,0v-2.4h2.4a.8.8,0,1,0,0-1.6h-2.4v-2.4a.8.8,0,1,0-1.6,0v2.4Z" transform="translate(-1594 -5836.529)" fill="#001630"/>
					<path id="Subtraction_23" data-name="Subtraction 23" d="M1607.4,5857H1606v-3a4,4,0,0,1,4-4h.4a4,4,0,0,1,4,4v3H1613v-2.7a2.8,2.8,0,0,0-5.6,0v2.7Z" transform="translate(-1590.1 -5840.801)" fill="#001630"/>
				  </svg>
				  
					</button>
			</div>
	`
	if ( amountindex == 1){
		itemHtml = itemHtml.replace(/{{quickAdd}}/g, "")
	}
	else {
		if (!isAccessory) {
			itemHtml = itemHtml.replace(/{{quickAdd}}/g, quickAddhtml)
		} else {
			itemHtml = itemHtml.replace(/{{quickAdd}}/g, "")
		}
	}
    
	let cusBirthday = false
	let cusAnniversary = false
	if (data.tags.length) {
		data.tags.forEach((tag) => {
			tag = tag.toLowerCase()
			if (tag.includes('gift:birthday') || tag.includes('gift:anniversary')) {
				// console.log(tag.split('gift:')[1])
				if (tag.split('gift:')[1] === 'birthday') {
					cusBirthday = true
				}
				if (tag.split('gift:')[1] === 'anniversary') {
					cusAnniversary = true
				}
			}
		})
	}
	data.variants.forEach((variant) => {
		// Size
		if (sizeIndex !== null) {
			const size = variant[`option${sizeIndex}`]

			if (!sizeItemsArray.includes(size)) {
				sizeItemsArray.push(size)
				const sizeClass = variant.available ? '' : ' disabled'
				
				let itemClasses = 'product-tile-sizes__item'
				let linkClasses = 'product-tile-sizes__link'

				if (jQ('body').hasClass('new-quick-add')) {
					itemClasses = 'product__list-item product__list-item--size'
					linkClasses = 'product-tile-modal__swatch product__swatch product__swatch--size'
				}

				sizeItems += `
					<li class="${itemClasses}">
						<a
							class="${linkClasses + ' ' + sizeClass}"
							data-product-size-available="${variant.available}"
							data-product-barcode="${variant.barcode}"
							data-product-compare-at-price="${variant.compare_at_price}"
							data-product-add-to-cart="${variant.id}"							
							data-pro-tag-cusbirthday = "${cusBirthday}"
							data-pro-tag-cusanniversary = "${cusAnniversary}"
						>${size}</a>
					</li>
				`
			}
		}

		// Color
		if (hiddenColors.includes(variantRealColor(variant))) {
			colorCount--
		}
	}) 

	// Quick Add Disable
	// let isWebExclusive = data.tags.some(tag => tag === 'web-exclusive')
	// let itemQuickAddDisabled = isWebExclusive ? ' disabled' : ''
	// itemHtml = itemHtml.replace(/{{itemQuickAddDisabled}}/g, itemQuickAddDisabled) 


		// Quick Add Disable
	let isgatted = data.tags.some(tag => tag === 'Gated Product')
	let itemQuickAddDisabled = isgatted ? ' disabled' : ''
	itemHtml = itemHtml.replace(/{{itemQuickAddDisabled}}/g, itemQuickAddDisabled) 
  
	// Reviews
	const currentUrl = window.current_url.toLowerCase();
	function generateItemRatingHTML(data, accessory) {
		if (typeof initRatingSnippet !== 'function') {
		  return "";
		}
	  
		const sku = accessory
		  ? `${data.variants[0].sku};${data.variants[0].sku.split('-')[0]}`
		  : data.variants[0].sku.split('-')[0];
	  
		return `
		  <div class="product-tile__rating">
			<div class="ruk_rating_snippet" data-sku="${sku}"></div>
			<div class="product-tile__rating-mask"></div>
		  </div>
		`;
	  }
	  
	  if (currentUrl.includes("accessory")) {
		const accessoryItemRating = generateItemRatingHTML(data, true);
		itemHtml = itemHtml.replace(/{{itemRating}}/g, accessoryItemRating);
	  } else {
		const nonAccessoryItemRating = generateItemRatingHTML(data, false);
		itemHtml = itemHtml.replace(/{{itemRating}}/g, nonAccessoryItemRating);
	  }
	  



	// if (typeof initRatingSnippet === 'function') {
	// 	const itemRating = `
	// 		<div class="product-tile__rating">
	// 			<div
	// 				class="ruk_rating_snippet"
	// 				data-sku="${data.variants[0].sku};${data.variants[0].sku.split('-')[0]}"
	// 			></div>
	// 			<div class="product-tile__rating-mask"></div>
	// 		</div>
	// 	`
	// 	itemHtml = itemHtml.replace(/{{itemRating}}/g, itemRating)
	// } else {
	// 	itemHtml = itemHtml.replace(/{{itemRating}}/g, "")
	// }

	// Badges
	let badge = null
	if (data.tags.includes('new')) {
		badge = 'New'
	}
	// If badge is exclusive then override 'New'
	if (data.tags.includes('web exclusives') || data.tags.includes('web-exclusive')) {
		badge = 'Exclusive'
	}

	// move Badge for A/B Testing
	const itemBadge = badge === null ? '' : `
		<div class="product-tile__note-wrap product-tile__note--new">
			<div class="product-tile__note product-tile__note--new">
				<span>${badge}</span>
			</div>
		</div>
	`
	itemHtml = itemHtml.replace(/{{itemBadge}}/g, itemBadge)

	// Add Colors
	if (colors !== undefined) {
		let itemColorCount = colorCount !== 1 ? `${colorCount} Colors` : `${colorCount} Color`
		itemHtml = itemHtml.replace(/{{itemColorCount}}/g, itemColorCount)
	} else {
		itemHtml = itemHtml.replace(/{{itemColorCount}}/g, '')
	}

	// Title and Options
	const objSplit = data.title.split('-')
	const options = objSplit[1]
	const title = objSplit[0]
	let presaleText = '';
	if(firstVariant.sku.includes('PRESALE')){ presaleText = 'presale-variant' }

	// Options
	itemHtml = itemHtml.replace(/{{itemOptions}}/g, options ? `<p class="product-tile__options">${options.trim()}</p>` : '')

	// Size Items
	itemHtml = itemHtml.replace(/{{itemSizes}}/g, sizeItems !== '' ? sizeItems : '')

	// Add main attribute (Always put at the end of this function)
	itemHtml = itemHtml.replace(/{{itemId}}/g, data.id)
	itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle)
	itemHtml = itemHtml.replace(/{{itemTitle}}/g, title ? title.trim() : data.title)
	// itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data))
	// itemHtml = itemHtml.replace(/{{itemFirstVariantUrl}}/g, this.buildProductItemUrl(data) + `?variant=${firstVariant.id}`)
	itemHtml = itemHtml.replace(/{{itemUrl}}/g, data.url)
	itemHtml = itemHtml.replace(/{{itemFirstVariantUrl}}/g, `${data.url}?variant=${firstVariant.id}`)
	itemHtml = itemHtml.replace(/{{itemType}}/g, metaSubtitle !== null ? metaSubtitle : data.product_type)
	itemHtml = itemHtml.replace(/{{itemFirstVariantSku}}/g, presaleText);
	return itemHtml
}

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {}

/** ************************ END BUILD PRODUCT LIST **************************/


/** ************************ Store Page Params in History State **************************/

BCSfFilter.prototype.changeAddressBar = function (a, b, c) {
  
  // HERE store page to history state instead of changing url
  if(b=='page') {
    window.history.replaceState({page:parseInt(a.split('page=')[1])},document.title);
    return;
  }
  var d = "?" + a.split("?")[1],
    e = d.substr(1).split("&");
  (1 != e.length && !1 !== this.checkExistFilterOptionParam()) || (a = e.length > 1 && !1 === this.checkExistFilterOptionParam() ? a.replace("&_=" + this.prefix, "") : a.replace("?_=" + this.prefix, ""));
  var f = document.title;
  void 0 === b || void 0 === c || "collection" != b || this.isSearchPage() || (f = this.textify(c) + " - " + this.shopName), History.pushState({ param: this.queryParams }, f, a);
}

BCSfFilter.prototype.scrollBackPositionHistoryBack = function () {
  if (this.getSettingValue("general.enableKeepScrollbackPosition")) {
    var a = jQ(this.selector.products).children();
    if (this.isAdvancedPaginationType() && a.length > 0) {
      var b = parseInt(this.queryParams.page);
      if (
          (a.each(function () {
              if (void 0 === jQ(this).attr("id")) {
                  var a = "";
                  jQ(this)
                      .find("a")
                      .each(function () {
                          var b = jQ(this).attr("href") || "";
                          if (b.length > 0 && b.match(/(?:\/products\/)(?:[^\?]*)/)) return (a = b.split("?")[0]), !1;
                      });
                  var c = a.toString().replace(/^_+|_+$|\//g, "") + "-" + b;
                  jQ(this).attr("id", c);
              }
              void 0 === jQ(this).data("page") && jQ(this).attr("data-page", b);
          }),
          this.isMobile())
      ) {
          var c = !1;
          a.on("touchstart", function () {
              c = !1;
          })
              .on("touchmove", function (a) {
                  c = !0;
              })
              .on("touchend", function (a) {
                  var b = jQ(this).attr("id") || !1;
                  if (!c && b) {
                      var d = new URL(window.location.href),
                          e = jQ(this).data("page") || 1,
                          f = { productId: b, page: e };

                      // HERE store page to history state instead of changing url
                      window.history.replaceState(f,document.title)
                      // null !== d.searchParams.get("page") && d.searchParams.delete("page"), parseInt(e) > 1 && d.searchParams.append("page", e), window.history.replaceState(f, "", d.toString().replace(/\+/g, "%20"));
                  }
              });
      } else
        a.click(function (a) {
          var b = jQ(this).attr("id") || !1;
          if (b) {
            var c = new URL(window.location.href),
                d = jQ(this).data("page") || 1,
                e = { productId: b, page: d };
            
            // HERE store page to history state instead of changing url
            window.history.replaceState(e,document.title)
            // null !== c.searchParams.get("page") && c.searchParams.delete("page"), parseInt(d) > 1 && c.searchParams.append("page", d), window.history.replaceState(e, "", c.toString().replace(/\+/g, "%20"));
          }
        });
      if (("scrollRestoration" in history && (history.scrollRestoration = "manual"), null !== history.state && history.state.hasOwnProperty("productId"))) {
        var d = new URL(window.location.href),
          e = history.state.productId;
        null !== e && (window.history.replaceState("", "", d.toString().replace(/\+/g, "%20")), jQ("html, body").animate({ scrollTop: jQ("#" + e).offset().top }, 0));
      }
    }
  }
}


/** ************************ Extract Page Params from History State **************************/
BCSfFilter.prototype.prepareRequestParams = function (a) {
  var b = mergeObject({}, this.queryParams);
  (b = this.prepareFilterParams(b, a)), (b = this.prepareSearchParams(b, a)), (this.queryParams = b);

  // HERE push page value into API query params spoofing url query param

  if(a=='init' && window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD){
    if(!window.history){
	if(!!window.history.state.page) {
      this.queryParams.page = window.history.state.page;
    }
	}
  }
  //console.log(a,this.queryParams)
}
BCSfFilter.prototype.prepareFilterParams = function (a, b) {
  if (this.queryParams.hasOwnProperty("collection_scope")) a.collection_scope = Array.isArray(this.queryParams.collection_scope) ? this.queryParams.collection_scope[0] : this.queryParams.collection_scope;
  else if (this.isSearchPage()) a.collection_scope = 0;
  else if (((a.collection_scope = parseInt(this.collectionId)), "history" == b)) {
      var c = History.getState().data;
      c.hasOwnProperty("param") && c.param.hasOwnProperty("collection_scope")
          ? (a.collection_scope = this.collectionId = parseInt(c.param.collection_scope))
          : (a.collection_scope = this.collectionId = parseInt(bcSfFilterConfig.general.collection_id));
  }
  if (
      (1 == this.getSettingValue("general.availableAfterFiltering")
          ? ((a.product_available = !0 === this.checkExistFilterOptionParam() || this.productAvailable), (a.variant_available = !0 === this.checkExistFilterOptionParam() || this.variantAvailable))
          : ((a.product_available = this.productAvailable), (a.variant_available = this.variantAvailable)),
      void 0 !== this.collectionTags && null !== this.collectionTags && (a.tag = this.collectionTags),
      this.getSettingValue("general.showOutOfStockOption") && (a.zero_options = !0),
      (a.build_filter_tree = !(void 0 !== b && this.imutableFilterTree.indexOf(b) > -1)),
      (a.check_cache = false),
      "" != this.getSettingValue("general.priceMode") && (a.price_mode = this.getSettingValue("general.priceMode")),
      "" != this.getSettingValue("general.tagMode") && (a.tag_mode = this.getSettingValue("general.tagMode")),
      this.getSettingValue("general.sortingAvailableFirst") && (a.sort_first = "available"),
      this.isVendorPage() && a.hasOwnProperty("q"))
  ) {
      (a[this.getSettingValue("general.vendorParam")] = [a.q]), delete a.q;
  }
  if (this.isTypePage() && a.hasOwnProperty("q")) {
      (a[this.getSettingValue("general.typeParam")] = [a.q]), delete a.q;
  }
  return a;
}



/** ************************ Add Reverse Infinite Scroll **************************/

window.docheight = function() {
  var body = document.body,
      html = document.documentElement;
  return Math.max( 
    body.scrollHeight, 
    body.offsetHeight, 
    html.clientHeight, 
    html.scrollHeight, 
    html.offsetHeight 
  )
}

let scrollPositionBefore = 0;
let scrollPositionAfter = 0;
window.scrollDirection = 'down';
window.addEventListener('scroll', (e) => {
  scrollPositionAfter = window.pageYOffset;
  if (scrollPositionBefore < scrollPositionAfter) {
    window.scrollDirection = 'down';
  } else if (scrollPositionBefore > scrollPositionAfter) {
    window.scrollDirection = 'up';
  }
  scrollPositionBefore = scrollPositionAfter;
});


BCSfFilter.prototype.buildLoadPreviousPageEvent = function (a) {
  var b = this;
  if (b.isLoadPreviousPagePaginationType()) {
    var c = jQ(b.getSelector("btnLoadPreviousPageWrapperSelector"));
    c.unbind("click"),
    c.on("click", function (a) {
      a.preventDefault();
      var c,
          d = parseInt(b.queryParams.page),
          e = jQ(this);
      if ((c = null != sessionStorage.getItem(b.getSettingValue("general.sessionStorageCurrentPreviousPage")) ? parseInt(sessionStorage.getItem(b.getSettingValue("general.sessionStorageCurrentPreviousPage"))) : d) < 2)
          return e.hide(), !1;
      (b.internalClick = !0), (b.queryParams.limit = b.getSettingValue("general.limit")), c--, (b.queryParams.page = c);
      var f = b.buildToolbarLink("page", d, c);
      sessionStorage.setItem(b.getSettingValue("general.sessionStorageCurrentPreviousPage"), c);
      sessionStorage.setItem(b.getSettingValue("general.sessionStoragePreviousPageEvent"), 1);
      b.onChangeData(f, "page");
      c < 2 && e.hide();
    });
  }
}


BCSfFilter.prototype.loadPreviousProducts = function (a) {

	//console.log('loadPreviousProducts');
	
  // return false;
  var b = this;
  b.isLoadPrevious = true;
  var previousPageNum = parseInt(jQ(b.selector.products).children()[0].dataset.page) - 1;
  if(previousPageNum > 0) {
    sessionStorage.setItem(b.getSettingValue("general.sessionStorageCurrentPreviousPage"), previousPageNum);
    sessionStorage.setItem(b.getSettingValue("general.sessionStoragePreviousPageEvent"), 1);
    b.onChangeData(b.buildToolbarLink('page', 1, previousPageNum),'page')
  }
  setTimeout(function(){
    b.isLoadPrevious = false;
    b.queryParams.page = Array.from(jQ(b.selector.products).children()).reverse()[0].dataset.page;
  },200)
  setTimeout(function(){
    b.isLoadingPrevious = false;
  },300)
}


BCSfFilter.prototype.isLoadPreviousPagePaginationType = function () {
  var a = this;
  return (
    (
      a.isLoadMorePaginationType() || a.isInfiniteLoadingPaginationType()
    ) 
      && 
    a.isAdvancedPaginationType() && 
    a.getSettingValue("general.activeLoadPreviousPage") && 
    (
      jQ(a.getSelector("btnLoadPreviousPageWrapperSelector")).length > 0 ||
      a.isLoadPrevious
    )
  );
}

BCSfFilter.prototype.buildProductListDataHtml = function (a) {
    
    var b = this;
    
    var heightBefore = docheight();
    var scrollBefore = window.scrollY;

    b.isLoadPreviousPagePaginationType() && 1 == sessionStorage.getItem(b.getSettingValue("general.sessionStoragePreviousPageEvent")) ? jQ(this.getSelector("products")).prepend(a) : jQ(this.getSelector("products")).append(a);

    var heightAfter = window.docheight();
    var heightVariance = heightAfter - heightBefore;
    var scrollAfter = scrollBefore + heightVariance;

    if(b.isLoadPrevious){
      window.scrollTo(0, scrollAfter )
    }
}

BCSfFilter.prototype.buildInfiniteLoadingEvent = function (a) {

  var b = this,
      c = parseInt(a.total_product),
      d = parseInt(b.getSettingValue("general.limit")),
      e = parseInt(b.queryParams.page);

  var total_page_count = Math.ceil(a.total_product / b.getSettingValue("general.limit"));
  var all_products = Array.from(jQ(b.selector.products).children());
  
  if(all_products.length >= a.total_product) return false;
  
  var first_product = all_products[0]
  var last_product = all_products.reverse()[0]

  // e = b.queryParams.page = Array.from(jQ(b.selector.products).children()).reverse()[0].dataset.page;

  b.isLoadPrevious = false;

  //console.log('buildInfiniteLoadingEvent')

  if (c > d * e) {

  	//console.log('listen to scroll')

      var f = 0,
          g = !1,
          h = jQ(b.getSelector("bottomPagination"));
      h.length > 0 && 
          jQ(window).scroll(function (c) {


  	//console.log(all_products.length)

              // HERE block the load of pages after last page
              if(all_products.length >= a.total_product || !all_products.length) return false;
              if(!last_product || last_product.dataset.page == total_page_count) return false;

              if (scrollDirection == 'down' && !b.isLoadPrevious  && (c.preventDefault(), c.stopPropagation(), jQ(b.selector.products).hasClass("bc-sf-product-loading"))) return !1;

              // b.queryParams.page = last_product.dataset.page + 1

              var d = jQ(window).height() * (jQ(window).height() / jQ(document).outerHeight()),
                  i = parseInt(h.offset().top),
                  j = parseInt(jQ(window).scrollTop()) + d + b.getSettingValue("general.positionShowInfiniteLoading");
              if ((jQ(window).scrollTop() + jQ(window).height() + d >= jQ(document).outerHeight() - 100 && (g = !0), 0 == f && a.products.length > 0 && (j >= i || (j < i && g)))) {
                  b.showLoadMoreLoading(), (f = 1), e++;
                  
                  if (e <= total_page_count)
                      if (((b.internalClick = !0), (b.queryParams.limit = b.getSettingValue("general.limit")), (b.queryParams.page = e), b.getSettingValue("general.paginationTypeAdvanced"))) {
                          var l = b.buildToolbarLink("page", e - 1, e);
                          b.onChangeData(l, "page");
                      } else b.getFilterData("page");
              }
          });
  }

  if(!all_products.length) return;

  b.first_product = jQ(b.selector.products).children()[0];
  
  if(!!b.first_product && b.first_product.dataset.page != '1'){

    jQ(window).scroll(function (event) {

      if (b.isLoadingPrevious) return false;
      if (scrollDirection == 'down' || jQ(b.selector.products).hasClass("bc-sf-product-loading")){return false;}

      if (b.first_product.getBoundingClientRect().top > 0) {
        
        b.isLoadingPrevious = true;
        b.loadPreviousProducts()

      }

    })

  }
}





// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
	if (this.getSettingValue('general.paginationType') == 'default') {
		// Get page info
		let currentPage = parseInt(this.queryParams.page)
		let totalPage = Math.ceil(totalProduct / this.queryParams.limit)

		// If it has only one page, clear Pagination
		if (totalPage == 1) {
			jQ(this.selector.bottomPagination).html('')
			return false
		}

		if (this.getSettingValue('general.paginationType') == 'default') {
			let paginationHtml = bcSfFilterTemplate.paginateHtml

			// Build Previous
			let previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1))
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml)

			// Build Next
			let nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1))
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml)

			// Create page items array
			let beforeCurrentPageArr = []
			for (let iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore)
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...')
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1)
			}
			beforeCurrentPageArr.push(currentPage)

			let afterCurrentPageArr = []
			for (let iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter)
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...')
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage)
			}

			// Build page items
			let pageItemsHtml = ''
			let pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr)
			for (let iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage])
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]))
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml)

			jQ(this.selector.bottomPagination).html(paginationHtml)
		}
	}
}

/** ************************ BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
	if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
		jQ(this.selector.topSorting).html('')

		let sortingArr = this.getSortingList()
		if (sortingArr) {
			// Build content
			let sortingItemsHtml = ''
			let selected = 'selected'

			if (!bcSfFilterSettings.general.pageLoad) {
				let selected = ''
			}

			sortingItemsHtml += `<option ${selected} value="featured">Sort</option>`

			for (let k in sortingArr) {
				sortingItemsHtml += `<option value="${k}">${sortingArr[k]}</option>`
			}

			let html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml)
			jQ(this.selector.topSorting).html(html)

			// Set current value
			if (!bcSfFilterSettings.general.pageLoad) {
				jQ(this.selector.topSorting + ' select').val(this.queryParams.sort)
			}

			bcSfFilterSettings.general.pageLoad = false
		}
	}
}

/** ************************ END BUILD TOOLBAR **************************/

// Build Default layout
function buildDefaultLink(a, b) { let c = window.location.href.split('?')[0]; return c += '?' + a + '=' + b }BCSfFilter.prototype.buildDefaultElements = function(a) { if (bcSfFilterConfig.general.hasOwnProperty('collection_count') && jQ('#bc-sf-filter-bottom-pagination').length > 0) { let b = bcSfFilterConfig.general.collection_count; let c = parseInt(this.queryParams.page); let d = Math.ceil(b / this.queryParams.limit); if (d == 1) return jQ(this.selector.pagination).html(''), !1; if (this.getSettingValue('general.paginationType') == 'default') { let e = bcSfFilterTemplate.paginateHtml; let f = ''; f = c > 1 ? bcSfFilterTemplate.hasOwnProperty('previousActiveHtml') ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousHtml : bcSfFilterTemplate.hasOwnProperty('previousDisabledHtml') ? bcSfFilterTemplate.previousDisabledHtml : '', f = f.replace(/{{itemUrl}}/g, buildDefaultLink('page', c - 1)), e = e.replace(/{{previous}}/g, f); let g = ''; g = c < d ? bcSfFilterTemplate.hasOwnProperty('nextActiveHtml') ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextHtml : bcSfFilterTemplate.hasOwnProperty('nextDisabledHtml') ? bcSfFilterTemplate.nextDisabledHtml : '', g = g.replace(/{{itemUrl}}/g, buildDefaultLink('page', c + 1)), e = e.replace(/{{next}}/g, g); for (var h = [], i = c - 1; i > c - 3 && i > 0; i--)h.unshift(i); c - 4 > 0 && h.unshift('...'), c - 4 >= 0 && h.unshift(1), h.push(c); for (var j = [], k = c + 1; k < c + 3 && k <= d; k++)j.push(k); c + 3 < d && j.push('...'), c + 3 <= d && j.push(d); for (var l = '', m = h.concat(j), n = 0; n < m.length; n++)m[n] == '...' ? l += bcSfFilterTemplate.pageItemRemainHtml : l += m[n] == c ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml, l = l.replace(/{{itemTitle}}/g, m[n]), l = l.replace(/{{itemUrl}}/g, buildDefaultLink('page', m[n])); e = e.replace(/{{pageItems}}/g, l), jQ(this.selector.pagination).html(e) } } if (bcSfFilterTemplate.hasOwnProperty('sortingHtml') && jQ(this.selector.topSorting).length > 0) { jQ(this.selector.topSorting).html(''); let o = this.getSortingList(); if (o) { let p = ''; for (let q in o)p += '<option value="' + q + '">' + o[q] + '</option>'; let r = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, p); jQ(this.selector.topSorting).html(r); let s = void 0 !== this.queryParams.sort_by ? this.queryParams.sort_by : this.defaultSorting; jQ(this.selector.topSorting + ' select').val(s), jQ(this.selector.topSorting + ' select').change(function(a) { window.location.href = buildDefaultLink('sort_by', jQ(this).val()) }) } } }

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function(data) { for (let k = 0; k < data.length; k++) { data[k]['images'] = data[k]['images_info']; if (data[k]['images'].length > 0) { data[k]['featured_image'] = data[k]['images'][0] } else { data[k]['featured_image'] = { src: bcSfFilterConfig.general.no_image_url, width: '', height: '', aspect_ratio: 0 } }data[k]['url'] = '/products/' + data[k].handle; let optionsArr = []; for (var i = 0; i < data[k]['options_with_values'].length; i++) { optionsArr.push(data[k]['options_with_values'][i]['name']) }data[k]['options'] = optionsArr; data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100; data[k]['price'] = data[k]['price_min']; data[k]['compare_at_price'] = data[k]['compare_at_price_min']; data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max']; let firstVariant = data[k]['variants'][0]; if (getParam('variant') !== null && getParam('variant') != '') { let paramVariant = data.variants.filter((e) => { return e.id == getParam('variant') }); if (typeof paramVariant[0] !== 'undefined')firstVariant = paramVariant[0] } else { for (var i = 0; i < data[k]['variants'].length; i++) { if (data[k]['variants'][i].available) { firstVariant = data[k]['variants'][i]; break } } }data[k]['selected_or_first_available_variant'] = firstVariant; for (var i = 0; i < data[k]['variants'].length; i++) { let variantOptionArr = []; let count = 1; let variant = data[k]['variants'][i]; let variantOptions = variant['merged_options']; if (Array.isArray(variantOptions)) { for (let j = 0; j < variantOptions.length; j++) { let temp = variantOptions[j].split(':'); data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1]; data[k]['variants'][i]['option_' + temp[0]] = temp[1]; variantOptionArr.push(temp[1]) }data[k]['variants'][i]['options'] = variantOptionArr }data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100; data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100 }data[k]['description'] = data[k]['content'] = data[k]['body_html'] } return data }

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {}

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
	const sidebar = jQ('[data-collection-filters-sidebar]')
	const filters = jQ('[data-collection-filters]')
	const $swiperContainer = jQ('.bc-sf-filter-selection-wrapper')
	const clearAll = `
		<div class="selected-item swiper-slide">
			<button
				type="button"
				class="clear-all"
				data-collection-filters-clear
				aria-label="Clear All"
				onclick="clearAllFilterOptions(event)"
			>Clear All</button>
		</div>
	`

	if ($swiperContainer) {
		$swiperContainer.addClass('swiper-container').attr({
			'data-swiper-carousel': '',
			'data-swiper-carousel-allow-touch-move': 'true',
			'data-swiper-carousel-free-mode': 'true',
			'data-swiper-carousel-loop': 'false',
			'data-swiper-carousel-slides-per-view': 'auto',
			'data-swiper-carousel-space-between': '5'
		}).find('.bc-sf-filter-selected-items').addClass('swiper-wrapper').find('> *').addClass('swiper-slide')

		if (!jQ('[data-collection-filters-clear]').length) {
			$swiperContainer.find('.bc-sf-filter-selected-items').append(clearAll)
		}

		new window.SwiperCarousel()

	}

	// Check if carousels exist
	if (typeof window.collections !== 'undefined') {
		const html = document.querySelector('html')

		if (isFiltered()) {
			html.classList.add('show-filter-results')
		} else {
			if (html.classList.contains('show-filter-results')) {
				html.classList.remove('show-filter-results')
			}

			if (window.VueCollection) {
				if (!window.VueCollection.$data.init) {
					window.VueCollection.fetchAllCarousels()
				}
			}
		}
	}

	// Filter display counts
	const productsCount = jQ('[data-collection-products-count]')

	if (isFiltered()) {
		const totalProductCount = `${data.total_product} Items`
		productsCount.text(totalProductCount)
	} else {
		productsCount.text('')
	}

	const filterCount = jQ('[data-collection-filter-count]')
	const filterMenuCount = jQ('[data-collection-menu-filter-count]')
	const filterMenuTop = jQ('[data-collection-filters-sidebar-top]')
	const filterOptions = sidebar.find('#bc-sf-filter-tree-h .bc-sf-filter-option-block')
	const activeFilters = filters.find('#bc-sf-filter-tree .selected-item.bc-sf-filter-option-label')
	const activeFiltersDisplay = activeFilters.length ? `( ${activeFilters.length} )` : ''
	const activeFiltersMenuDisplay = activeFilters.length ? `Clear All (${activeFilters.length})` : 'Filter + Sort'

	filterCount.text(activeFiltersDisplay)
	filterOptions.addClass('active-toggle')
	filterMenuCount.text(activeFiltersMenuDisplay)

	if (activeFilters.length) {
		filterMenuCount.addClass('active')
		filterMenuTop.addClass('filtered')
		if (window.scrollY > 0 || document.documentElement.scrollTop > 0) {
			// Scroll the page to the top
			window.scrollTo({
			  top: 0,
			  behavior: 'smooth' // You can change this to 'auto' for instant scrolling
			});
		  }
	} else {
		filterMenuCount.removeClass('active')
		filterMenuTop.removeClass('filtered')
	}

	// Events
	collectionEvents()
	window.closeBCSFQuickAdd = function() {
		jQ('html').removeClass('product-quick-add-modal-active--bcsf')
	}

	// Sort dropdown
	const params = new URLSearchParams(window.location.search)
	const filtersSidebar = document.querySelector('[data-collection-filters-sidebar]')
	const removeSort = localStorage.getItem('remove_sort')

	if (filtersSidebar) {
    const sort = $(filtersSidebar.querySelector('#collection-sort'))
		const sortResetValue = sort.find('option:first-child').val()

		if (params.has('sort') && !removeSort) {
      sort.val(params.get('sort')).trigger('change')
		} else {
			if (removeSort) {
				localStorage.removeItem('remove_sort')
				window.history.pushState({}, null, window.location.pathname)
			}

			sort.val(sortResetValue).trigger('change')
		}

		sort.select2({
      width: '100%'
		})

		sort.on('select2:select', (e) => {
      onInteractWithToolbar(e, 'sort', this.queryParams.sort, e.params.data.id)
		})

		// Sidebar clear all
		jQ('body').on('click', '[data-collection-filters-sidebar-clear], [data-collection-filters-clear]', () => {
			if (params.has('sort')) {
				localStorage.setItem('remove_sort', true)
			}
		})
	}

	// Option blocks
	setTimeout(() => {
		const title = sidebar.find('#bc-sf-filter-tree-h .bc-sf-filter-block-title')

		title.each(function () {
			const el = jQ(this)
			const container = el.closest('.bc-sf-filter-option-block')
			const content = container.find('.bc-sf-filter-block-content')

			content.removeAttr('style')

			el.append(`
				<button type="button" class="collection-filters-sidebar__title-button" data-filter-event type="button">
					<span class="visually-hidden">Toggle ${el.find('a span').text()} filters</span>
				</button>
			`)

			el.find('[data-filter-event]').on('click', () => {
				container.toggleClass('active-toggle')
			})
		})
	}, 1)

	// Search Page
	jQ('[data-search-result-number]').text(`All (${data.total_product})`)

	// Reviews
	if (typeof initRatingSnippet === 'function') {
		setTimeout(()=>{
			const currentUrl = window.current_url.toLowerCase();
			if (currentUrl.includes("accessory")) {
				initRatingSnippetAccessory()
			} else {
				initRatingSnippet()
			}
		},200)
		
	}

	if (window.carouselToggled) document.documentElement.classList.remove('show-filter-results', 'filters-active')

	if (jQ('body').hasClass('new-quick-add') && !jQ('.product-tile-modal--bcsf').length) {
		// if(jQ('html').hasClass('show-filter-results')) {
		jQ('body').append(`
			<div class="product-tile-modal product-tile-modal--bcsf">
				<button type="button" class="product-tile-modal__overlay" aria-label="Close Quick Add" onclick="window.closeBCSFQuickAdd()"></button>
				<div class="product-tile-modal__content-wrap"></div>
			</div>
		`)
		// }
	}
}

BCSfFilter.prototype.buildSubmitEvent = function(a, b, c) {
	const search = jQ('.search')
	const filtersContainer = search.find('.plp__filters')

	setTimeout(() => {
		filtersContainer.css('margin-bottom', '')

		search.find(`${this.selector.filterTreeHorizontal} .${this.class.filterBlockContent}`).each(function () {
			const el = jQ(this)

			if (el.css('display') === 'block') {
				const filterHeight = el.outerHeight()

				filtersContainer.css('margin-bottom', `${filterHeight}px`)
				return false
			}
		})
	}, 1)

	search.find('.bc-sf-filter-clear-all').on('click', (e) => {
		$(e.currentTarget).hide()
		search.find(`${this.selector.filterTreeHorizontal} .${this.class.filterBlockContent}`).hide()
		filtersContainer.css('margin-bottom', '')
	})

	// Custom code that wasn't part of buildSubmitEvent() in bc-sf-filtter-lib.js
	// Check if any filter dropowns are visible and toggle class on docment to push content below up/down
	/*
	var filterIsOpen = false

  setTimeout(() => {
    jQ(this.selector.filterTreeHorizontal).find("." + this.class.filterBlockContent).each(function() {
      if (jQ(this).css("display") === "block") {
        filterIsOpen = true
        return false
      }
    })

    if (filterIsOpen) {
      jQ('html').addClass('filters--open')
    } else {
      jQ('html').removeClass('filters--open')
    }
  }, 1)

  var d = jQ(this.selector.filterTreeHorizontal).find("." + this.class.filterBlockContent).filter(function() {
      return "block" == jQ(this).css("display")
  	}).eq(0),
		e = jQ(d[0]).parent();

	jQ("#" + this.selector.filterOptionOpenValue).val(jQ(d[0]).attr("id"));

	var f = e.data("type")
    , g = e.data("display-type")
    , h = e.data("select-type")
    , i = e.attr("data-id")
    , j = [];

		e.find(".noUi-target").length > 0 && e.find(".noUi-target").hasClass("selected") ? j.push(e.find(".noUi-target").attr("data-value")) : jQ(d).find("ul").children().each(function() {
      jQ(this).children().first().hasClass("selected") && j.push(jQ(this).children().first().attr("data-value"))
  });

	var k = this.buildSubmitLink(i, j, f, g, h);
  !1 !== k && !0 === this.selectFilter && (jQ("#" + this.selector.filterOptionSubmitOpenValue).val(jQ(d[0]).attr("id")),
  this.internalClick = !0,
  this.onChangeData(k, f, j, i));
  var l = jQ(this.selector.filterTreeHorizontal).find("." + this.class.filterBlockTitle);
  (!b || b && !l.is(c.target) && 0 === l.has(c.target).length) && (jQ(this.selector.filterTreeHorizontal).find("." + this.class.filterBlockContent).hide(),
	jQ(this.selector.filterTreeHorizontal).find("." + this.class.filterBlockTitle).children("a").removeClass("selected"))
	*/
}

/*
BCSfFilter.prototype.buildCollectionPromo = function() {
	let itemHtml

	if (localCollectionPromoImages.logo.includes('no-image') || localCollectionPromoImages.logoMobile.includes('no-image')) {
		itemHtml = bcSfFilterTemplate.collectionPromoNoLogoHtml
	} else {
		itemHtml = bcSfFilterTemplate.collectionPromoHtml
	}

	return itemHtml
}
*/

BCSfFilter.prototype.buildFilterShowLimit = function() {
	if (bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
		jQ('#bc-sf-filter-top-show-limit').html('');

		var numberList = '12,24,32,48'

		if (numberList != '') {
			// Build content
			var showLimitItemsHtml = ''
			var arr = numberList.split(',')
			for (var k = 0; k < arr.length; k++) {
				var label = arr[k];
				showLimitItemsHtml += '<option value="' + arr[k] +'">' + label + '</option>'
			}

			var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml)

			jQ('#bc-sf-filter-top-show-limit').html(html)

			// Set value
			jQ('#bc-sf-filter-top-show-limit select').val(this.queryParams.limit)
		}
	}
}

BCSfFilter.prototype.showError = function(a) {
	jQ('#bc-sf-filter-products').addClass('showerror')
}

/** ************************ Events **************************/

function collectionEvents() {
	// Alt Image
	jQ('body').on('mouseover', '[data-toggle-product-image]', (e) => {
		const el = jQ(e.currentTarget)
		el.addClass('hover')
	})

	jQ('body').on('mouseleave', '[data-toggle-product-image]', (e) => {
		const el = jQ(e.currentTarget)
		el.removeClass('hover')
	})

	// Quick add
	jQ('body').on('mouseover', '[data-product-item]', (e) => {
		const el = jQ(e.currentTarget)
		el.addClass('quick-hover')
	})

	jQ('body').on('mouseleave', '[data-product-item]', (e) => {
		const el = jQ(e.currentTarget)
		el.removeClass('quick-hover')
	})

	jQ('body').on('click', '[data-product-quick-add]', (e) => {
		const el = jQ(e.currentTarget)
		const container = el.closest('[data-product-item]')
		const showModal = jQ('body').hasClass('new-quick-add')
		const modalContent = el.parents('.product-tile').find('[data-quick-add-content]')

		if (showModal && modalContent) {
			jQ('.product-tile-modal--bcsf .product-tile-modal__content-wrap').html(modalContent.html())
			jQ('html').addClass('product-quick-add-modal-active--bcsf')
			if (typeof initRatingSnippet === 'function') {
				initRatingSnippet()
			}
		} else {
			container.addClass('clicked')
		}
	})

	// Size events
	jQ('body').on('mouseover', '[data-product-sizes] *', (e) => {
		const el = jQ(e.currentTarget)
		const container = el.closest('[data-product-item]')
		container.addClass('clicked')
	})

	jQ('body').on('mouseleave', '[data-product-sizes]', (e) => {
		const el = jQ(e.currentTarget)
		const container = el.closest('[data-product-item]')
		container.removeClass('clicked')
	})

	jQ('body [data-collection-results]').on('click', (e) => {
		const el = jQ(e.target)
		const clicked = jQ('[data-product-item].clicked')

		if (window.innerWidth < 1025) {
			if (!el.hasClass('product-tile__quick-add-mobile__button')) {
				clicked.removeClass('clicked')
			}
		} else {
			if (!el.hasClass('product-tile__quick-add')) {
				clicked.removeClass('clicked')
			}
		}
	})

	// Add to cart
	jQ('body').on('click', '[data-product-add-to-cart]', (e) => {
		//console.log("bc-sf-filter.js")
		const el = jQ(e.currentTarget)
		const barcode = el.data('product-barcode') === 'null' ? null : el.data('product-barcode')
		const compareAtPrice = el.data('product-compare-at-price') === 'null' ? null : el.data('product-compare-at-price')
		const tagCusBirthday = el.data('pro-tag-cusbirthday')
		const tagCusAnniversary = el.data('pro-tag-cusanniversary')
		const id = el.data('product-add-to-cart')
		const available = el.data('product-size-available')
		//console.log("tagCusBirthday ", tagCusBirthday, " tagCusAnniversary ", tagCusAnniversary)

		if (available) {
			const item = {
				id: id,
				quantity: 1,
				properties: {
					'_quick_add': true,
					'_compare_at_price': compareAtPrice ? slate.Currency.formatMoney(compareAtPrice, '{{amount}}') : compareAtPrice,
					'_upc': barcode,
					'_birthday_gift': tagCusBirthday,
					'_anniversary_gift': tagCusAnniversary
				}
			}

			window.closeBCSFQuickAdd()
			VueMinicart.$store.dispatch('addItem', item)
			rdt('track', 'AddToCart')
		}
	})
}

// Carousel / Grid toggle button
jQ('body').on('click', '[data-filters-toggle-view]', e => {
	const $el = e.target
	const type = $el.dataset.filtersToggleView
	const params = new URLSearchParams(window.location.search)

	jQ($el).addClass('active').siblings().removeClass('active')

  // Trigger change on the original sorting select
  // jQ('#collection-sort').val(type === 'carousel' ? 'featured' : 'best-selling').trigger('change')

	if (type === 'carousel') {
		window.carouselToggled = true

		if (window.VueCollection) {
			if (!window.VueCollection.$data.init) {
				const force = true
				window.VueCollection.fetchAllCarousels(force)
			} else {
				// setTimeout(() => {
				// 	document.documentElement.classList.remove('show-filter-results', 'filters-active')
				// }, 500)
			}
		}

		if (params.has('pv')) {
			params.delete('pv')
		}

		const queries = params.toString() !== '' ? `?${params.toString()}` : ''

		window.location.href = `${window.location.pathname}${queries}`
	} else {
		if (params.has('pv')) {
			params.delete('pv')
		}

		const queries = params.toString() !== '' ? `?${params.toString()}&pv=${type}` : `?pv=${type}`

		window.location.href = `${window.location.pathname}${queries}`
		window.carouselToggled = false
		// document.querySelector('.collection-filters-sidebar-top__close').click()
	}
})
